function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 30.625C16.7165 30.625 17.5 29.8415 17.5 28.875C17.5 27.9085 16.7165 27.125 15.75 27.125C14.7835 27.125 14 27.9085 14 28.875C14 29.8415 14.7835 30.625 15.75 30.625Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 30.625C27.2165 30.625 28 29.8415 28 28.875C28 27.9085 27.2165 27.125 26.25 27.125C25.2835 27.125 24.5 27.9085 24.5 28.875C24.5 29.8415 25.2835 30.625 26.25 30.625Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1875 16.8C30.1525 16.765 30.135 16.73 30.1 16.6775C29.435 15.7675 28.49 15.75 28.49 15.75H13.51C13.51 15.75 12.565 15.7675 11.9 16.695C11.865 16.73 11.8475 16.765 11.8125 16.8C11.69 16.9925 11.5675 17.22 11.48 17.5C11.095 18.655 10.185 21.385 8.75 25.7075V37.0825C8.75 37.87 9.3625 38.5 10.115 38.5H10.885C11.6375 38.5 12.25 37.87 12.25 37.0825V35H29.75V37.0825C29.75 37.87 30.345 38.5 31.115 38.5H31.885C32.6375 38.5 33.25 37.87 33.25 37.0825V25.7075C31.815 21.4025 30.905 18.655 30.52 17.5C30.4325 17.22 30.31 16.9925 30.1875 16.8ZM14.5775 19.25H27.4225L27.825 20.4575L28.5775 22.75H13.4225L14.5775 19.25ZM29.75 31.5H12.25V26.2675V26.25H29.75V26.2675V31.5Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9525 5.25C18.2175 3.2025 16.275 1.75 14 1.75C11.095 1.75 8.75 4.095 8.75 7C8.75 9.8875 11.095 12.25 14 12.25C16.275 12.25 18.2175 10.78 18.9525 8.75H28V12.25H31.5V8.75H33.25V5.25H18.9525ZM14 8.75C13.0375 8.75 12.25 7.9625 12.25 7C12.25 6.0375 13.0375 5.25 14 5.25C14.9625 5.25 15.75 6.0375 15.75 7C15.75 7.9625 14.9625 8.75 14 8.75Z",
  fill: "white"
});

function SvgCarRental(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarRental);
export default __webpack_public_path__ + "static/media/car-rental.21477d9a.svg";
export { ForwardRef as ReactComponent };